<template>
    <b-modal id="id-modal-upload-components-to-danger" size="xl" :title="getTitleModal" hide-footer scrollable
      no-close-on-backdrop no-close-on-esc>
      <template #modal-header-close>
        <b-button @click="closeModal" variant="light">
          <i class="fa fa-close fa-lg"></i>
        </b-button>
      </template>
      <div>
        <!-- Formulario -->
        <b-form @submit.prevent="onSubmit" enctype="multipart/form-data">
          
          <!-- Registro de procesos -->
          <div v-show="isShowReport">
            <!-- Cabecera -->
            <div class="bg-gray-100 p-3 d-flex align-items-center justify-content-center">
              Registros del proceso
            </div>
            <b-table hover :items="responseUpFileExcelComponents" :fields="fields" responsive="sm" select-mode="multi" selectable bordered >
              
              <!-- Fila -->
              <template #cell(row)="component">
                {{ component.item.row }}
              </template>
              <!-- Fila -->
              <template #cell(cas_number)="component">
                {{ component.item.cas_number }}
              </template>
              <!-- Fila -->
              <template #cell(name)="component">
                {{ component.item.name }}
              </template>
              <!-- Fila -->
              <template #cell(errors)="component">
                <ul class="m-0 py-0 px-2">
                    <li v-for="(error, indexError) in component.item.errors" :key="indexError">
                      <span v-for="(errorText, indexErrorText) in getErrorsByItem(error, indexError)" :key="indexErrorText">
                        {{ errorText.errors }}
                      </span>
                    </li>
                  </ul>
              </template>
            </b-table>
            <!-- Botones de acciones -->
            <div class="d-flex justify-content-between mt-3">
              <b-button variant="light" @click="closeModal">
                <i class="fa fa-close mr-1"></i>
                Salir
              </b-button>
              <b-button variant="light" @click="closeModalAndUploadNew">
                <i class="fa fa-close mr-1"></i>
                Cerrar reporte, y cargar de nuevo
              </b-button>
            </div>
          </div>
          <div v-show="!isShowReport">
            <b-form-group id="group-file-excel" label="Documento excel (*)" label-for="file-excel"
              description="Solo se permiten el tipo de archivos: .xls, .xlsx">
              <b-form-file id="file-excel" v-model="form.file" accept=".xls,.xlsx,.ods" ref="fileExcelComponents"
                class="mb-2" placeholder="Cargar documento excel..." required></b-form-file>
            </b-form-group>
            <!-- Botones de acciones -->
            <div class="d-flex justify-content-between mt-3">
              <b-button variant="light" @click="closeModal">
                <i class="fa fa-close mr-1"></i>
                Cancelar
              </b-button>
              <b-button v-if="form.file" variant="primary" @click.prevent="onSubmit">
                <i class="fa fa-upload mr-1"></i>
                Cargar documento
              </b-button>
            </div>
          </div>
        </b-form>
      </div>
    </b-modal>
  </template>
  <script>
  // Importaciones generales
  import { mapState, mapMutations, mapActions } from 'vuex';
  export default {
    name: "UploadExcelComponentsToDanger",
    components: {
    },
    data() {
      return {
        form: {
          file: null,        
        },
        fields: [
            {
              key: 'row',
              label: 'FILA',
              sortable: true
            },
            {
              key: 'cas_number',
              label: 'CAS',
              sortable: true
            },
            {
              key: 'name',
              label: 'COMPONENTE',
              sortable: true
            },
            {
              key: 'errors',
              label: 'ERRORES'
            },
          ]
      }
    },
    computed: {
      ...mapState('dashboard', {
        loadingDataTable: 'loading'
      }),
      ...mapState('nuevocas', {
        currentDangerActive: 'currentDangerActive',
        responseUpFileExcelComponents: 'responseUpFileExcelComponents'
      }),
      getTitleModal() {
        return this.currentDangerActive ? this.currentDangerActive.lista : ''
      },
      isShowReport() {
        return this.responseUpFileExcelComponents && typeof this.responseUpFileExcelComponents === 'object'
      }
    },
    methods: {
      ...mapActions('nuevocas', [
        'listarTipoCas',
        'uploadRegistersDanger'
      ]),
      ...mapMutations('nuevocas', [
        'setCurrentDangerActive',
        'setResponseUpFileExcelComponents'
      ]),
      showModal() {
        this.setResponseUpFileExcelComponents(null);
        this.$bvModal.show('id-modal-upload-components-to-danger')
      },
      async closeModal() {
        this.clearFiles()
        this.setCurrentDangerActive(null)
        this.setResponseUpFileExcelComponents(null);
        this.$bvModal.hide('id-modal-upload-components-to-danger')
      },
      closeModalAndUploadNew() {
        this.clearFiles()
        this.setResponseUpFileExcelComponents(null);
      },
      clearFiles() {
        if (this.form.file) this.$refs['fileExcelComponents'].reset()
      },
      async onSubmit(event) {
        event.preventDefault()
        await this.uploadRegistersDanger({ 
          danger: this.currentDangerActive,
          file: this.form.file
        })
      },
      getErrorsByItem(errors, indexError) {
        let items = []
        Object.values(errors).forEach(x => {
          let currentItem = items.find(i => i.title == indexError)
          if (currentItem) {
            currentItem.errors = currentItem.errors+" "+x
          } 
          else {
            items.push({
              'title': indexError,
              'errors': x
            })
          }       
        });
        return items
      },
      getErrorsByItemLength(errors) {      
        let items = []
        Object.values(errors).forEach(x => x.map(i => items.push(i)));
        return items.length
      }
    }
  }
  </script>
  <style scoped></style>